import type { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { AccountsLayout } from './accounts/AccountsLayout';

const SUBTITLE = {
  recover: 'accounts.sub.recover',
  invite: 'accounts.sub.invite',
  handoff: 'accounts.sub.handoff',
} as const;

interface Props {
  /** Heading of the card; omitted when the content brings its own (second-factor steps). */
  title?: string | undefined;
  /** What the page is for: it sets the line under the greeting. */
  purpose: keyof typeof SUBTITLE;
  children: ReactNode;
}

/** The accounts desk for every page outside the shell besides sign-in: password recovery and
 *  reset, invitation. Same territory, greeting, topbar and footer as the sign-in page. */
export function AuthCard({ title, purpose, children }: Props) {
  return (
    <AccountsLayout subtitle={<Trans i18nKey={SUBTITLE[purpose]} components={{ b: <b /> }} />}>
      <div className="acc-view">
        {title === undefined ? null : <h2>{title}</h2>}
        {children}
      </div>
    </AccountsLayout>
  );
}
